import { getOwnProfile } from 'actions/profile-actions'
import { submitPsq } from 'actions/psq-actions'
import Storage from 'modules/storage'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectOwnProfile,
  selectOwnProfileError,
  selectOwnProfileLoading,
  selectPsqSubmitted,
} from 'redux/selectors'
import { PersonPSQAnswerInput } from 'types/api/types'
import { PersonIDEnum } from 'types/global'

export const useSubmitPublicRmg = (answers: PersonPSQAnswerInput[] | null) => {
  const dispatch = useDispatch()
  const ownProfile = useSelector(selectOwnProfile)
  const ownProfileLoading = useSelector(selectOwnProfileLoading)
  const ownProfileError = useSelector(selectOwnProfileError)
  const rmgSubmitted = useSelector(selectPsqSubmitted)
  const [canActivate, setCanActivate] = useState(false)

  useEffect(() => {
    if (answers && ownProfile) {
      dispatch(
        submitPsq(
          { identifier: ownProfile.id, type: PersonIDEnum.ID },
          { answers: answers, gender: ownProfile.sex, age: ownProfile.age }
        )
      )
    } else if (answers && !ownProfile && !ownProfileLoading) {
      dispatch(getOwnProfile())
    }
  }, [dispatch, answers, ownProfile, ownProfileLoading])

  useEffect(() => {
    if (!answers || rmgSubmitted || ownProfileError) {
      Storage.clearPublicRmg()
      setCanActivate(true)
    }
  }, [rmgSubmitted, ownProfileError, answers])

  return canActivate
}
